export function isName(value) {
    if (!value) return true;
    return new RegExp(/^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/g).test(value);
}

export function isMobileNumber(value) {
    if (!value) return true;
    return new RegExp(/^[0][6-9]\d{9}$|^[6-9]\d{9}$/g).test(value);
}

export function isPinCodeNumber(value) {
    if (!value) return true;
    return new RegExp(/^(\d{4}|\d{6})$/g).test(value);
}

export function isAadhaarCardNumber(value) {
    if (!value) return true;
    return new RegExp(/^(\d{12}|\d{16})$/g).test(value);
}

export function isPanCardNumber(value) {
    if (!value) return true;
    return new RegExp(/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/g).test(value);
}
